import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteGroupCommunity",
  tabindex: "-1",
  "aria-labelledby": "deleteGroupCommunity",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteGroupCommunity"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "text-center my-3" }
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "modal fade",
  id: "deleteGroupSuccess",
  tabindex: "-1",
  "aria-labelledby": "deleteGroupSuccess",
  "aria-hidden": "true"
}
const _hoisted_11 = { class: "modal-dialog" }
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = { class: "modal-header" }
const _hoisted_14 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_16 = { class: "modal-body border-bottom" }
const _hoisted_17 = {
  class: "modal-title w-100 text-center",
  id: "deleteGroupSuccess"
}
const _hoisted_18 = { class: "modal-body d-flex justify-content-center" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  class: "modal fade",
  id: "deleteGroupSuccess",
  tabindex: "-1",
  "aria-labelledby": "deleteGroupSuccess",
  "aria-hidden": "true",
  "data-bs-keyboard": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_21 = { class: "modal-dialog" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "modal-header" }
const _hoisted_24 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_25 = { class: "modal-body" }
const _hoisted_26 = {
  class: "modal-title w-100 text-center",
  id: "deleteGroupSuccess"
}
const _hoisted_27 = { class: "modal-body d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'

import groupsService from '@/services/groups.service'
import { useStore } from 'vuex'
import { GROUPS_STORE } from '@/store/constants'
import { onMounted, ref } from 'vue'

import { useRoute, useRouter } from 'vue-router'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  groupId: String,
  groupName: String,
},
  setup(__props) {

const props = __props

const route = useRoute()
const router = useRouter()

const deleteFailed = ref<boolean>(false)
const store = useStore()
const loadingDelete = ref<boolean>(false)


// 2022/09/15 TienNV Fix double click button confirm delete
const modalConfirm = ref()
const modalSuccess = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('deleteGroupCommunity'))
  modalSuccess.value = new Modal(document.getElementById('deleteGroupSuccess'))
})

const DeleteAGroup = async () => {
  loadingDelete.value = true
  try {
    const response = await groupsService.deleteGroupApi(props.groupId, { create_by_admin: true })
    if (response?.status === 200) {
      deleteFailed.value = false

      const payload = {
        id: route.params?.id,
        params: {
          group_type: '3',
          ...route.query,
          page: route.query?.page || 1,
          page_of_number: route.query?.page_of_number || 30,
          published: route.query?.published ? '' : true,
          create_by_admin: true,
        },
      }
      store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_GROUPS, payload)
    } else {
      deleteFailed.value = true
    }
    //2022/09/15 TienNV Fix double click button confirm delete
    modalConfirm.value.hide()
    modalSuccess.value.show()
    setTimeout(() => {
      loadingDelete.value = false
    }, 2000)
  } catch (error) {
    loadingDelete.value = false
    console.log(error)
    deleteFailed.value = true
    modalConfirm.value.hide()
    modalSuccess.value.show()
  }
}

const backToGroups = () => {
  if (!deleteFailed.value) router.push(`/${route.path.split('/')[1]}/communities/${route.params.id}/groups`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('SN10deleteGroup')), 1),
              _hoisted_6
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(translate)('group')) + " 「" + _toDisplayString(__props.groupName) + "」" + _toDisplayString(_unref(translate)('deleteGroupName')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                class: "me-2",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('deleteButton'),
                onClick: DeleteAGroup,
                loading: loadingDelete.value,
                disabled: loadingDelete.value,
                className: 'fw-bold',
                type: 'secondary'
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ])
        ], 32)
      ])
    ]),
    (_unref(route).path !== `/alumni/communities/${_unref(route).params.id}/groups/${_unref(route).params.group_id}/users`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h5", _hoisted_14, _toDisplayString(_unref(translate)('SN10deleteGroup')), 1),
                  _hoisted_15
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, _toDisplayString(deleteFailed.value ? _unref(translate)('errorDeleteGroup') : _unref(translate)('deleteSuccess')), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(Button, {
                    title: _unref(translate)('close'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal",
                    class: "me-2",
                    size: 'small',
                    className: 'fw-bold'
                  }, null, 8, ["title"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(route).path === `/alumni/communities/${_unref(route).params.id}/groups/${_unref(route).params.group_id}/users`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("h5", _hoisted_24, _toDisplayString(_unref(translate)('SN10deleteGroup')), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("p", _hoisted_26, _toDisplayString(deleteFailed.value ? _unref(translate)('errorDeleteGroup') : _unref(translate)('deleteHistorySuccess')), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(Button, {
                    title: _unref(translate)('close'),
                    type: 'secondary',
                    class: "me-2",
                    onClick: backToGroups,
                    "data-bs-dismiss": "modal",
                    size: 'small',
                    className: 'fw-bold'
                  }, null, 8, ["title"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})